import * as RadixTooltip from "@radix-ui/react-tooltip";
import type { ReactNode } from "react";

export function InfoTooltip(props: { content: ReactNode; children?: ReactNode }) {
  return (
    <RadixTooltip.Root delayDuration={150}>
      <RadixTooltip.Trigger asChild>
        {props.children ?? (
          <span className="info-mark" aria-label="More info">
            i
          </span>
        )}
      </RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content className="tooltip" sideOffset={4}>
          {props.content}
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
}

export function TooltipRoot(props: { children: ReactNode }) {
  return <RadixTooltip.Provider>{props.children}</RadixTooltip.Provider>;
}
